import PropTypes from 'prop-types'
import { useContext } from 'react'
import { Link } from 'react-router'

import logo from '@/assets/images/logo.png'
import { UserStoreContext } from '@/stores/UserStore'

/**
 * SharedLegalLayout
 *
 * Parent component for all legal pages, provides a consistent layout and prose styling.
 */
const SharedLegalLayout = ({ heading, children }) => {
  // Contexts
  const { isAuthenticated } = useContext(UserStoreContext)

  return (
    <div className="bg-muted flex min-h-svh flex-col items-center justify-center p-6 md:p-10">
      <header className="h-32">
        <img src={logo} alt="Logo" className="h-8" />
      </header>
      <main className="prose mx-auto flex w-full max-w-sm grow flex-col justify-center px-4 sm:px-6 md:max-w-4xl lg:px-8">
        <div className="mb-8 flex w-full flex-row items-center justify-between gap-4">
          <h1>{heading}</h1>
          {!isAuthenticated && (
            <Link
              to="/login"
              className="text-sm leading-[14px] font-semibold tracking-[1.5px] text-blue-800 uppercase hover:text-blue-900"
            >
              Log In
            </Link>
          )}
        </div>

        {/* Children */}
        {children}
      </main>
    </div>
  )
}

SharedLegalLayout.propTypes = {
  heading: PropTypes.string.isRequired,
  children: PropTypes.node,
}

export default SharedLegalLayout
